import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';
import uploadCampaignList from './modules/UploadCampaignList';
import sendTest from './modules/SendCampaignTest';
import sendCampaign from './modules/SendCampaign';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}


const MailerCampaign: React.FC = () => {
  const endpoint = '/mailer-campaign';
  const title = 'Campanha';

  const { projectHash, eventHash } = useParams<Record<string, any>>();


  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },
    project_id: { ref: 'project_id', column: 'project_id', label: 'Projeto', show: false },
    title: { ref: 'title', column: 'title', label: 'Título' },

    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {
    title: { model: 'input', type: 'text', name: 'title', label: 'Título do e-mail' },

    start_at: { model: 'datePicker', type: 'text', name: 'start_at', label: 'Data de envio' },



    header: {
      model: 'imageSingle',
      type: 'upload',
      name: 'header',
      label: 'Cabeçalho',
      list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ],
    },

    description: { model: 'richText', type: 'text', name: 'description', label: 'Texto de abertura' },



    content_highlight: {
      model: 'JsonInput',
      project_id: projectHash,
      bodyRender: (data: Record<string, any>) => (
        <nav>
          <strong>
            (
            {data._id})
            {' '}
            {data.title}
          </strong>
        </nav>
      ),
      searchRender: (data: Record<string, any>) => (
        <>
          <strong>
            (
            {data._id})
            {' '}
            {data.title}
          </strong>
        </>
      ),
      storageType: 'data',
      endpoint: `/news`,
      name: 'content_highlight',
      label: 'Notícias em destaque',
    },

    content: {
      model: 'JsonInput',
      project_id: projectHash,
      bodyRender: (data: Record<string, any>) => (
        <nav>
          <strong>
            (
            {data._id})
            {' '}
            {data.title}
          </strong>
        </nav>
      ),
      searchRender: (data: Record<string, any>) => (
        <>
          <strong>
            (
            {data._id})
            {' '}
            {data.title}
          </strong>
        </>
      ),
      storageType: 'data',
      endpoint: `/news`,
      name: 'content',
      label: 'Notícias',
    },

    footer: {
      model: 'imageSingle',
      type: 'upload',
      name: 'footer',
      label: 'Rodapé',
      list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ],
    },


  };

  const formSchemaUpdate = {

    ...formSchema



  };

  const formValidation: Record<string, ValidationSchema> = {

  };

  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,

        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,

        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,

        }),
      (lineData: Record<string, any>) =>
        uploadCampaignList({
          lineData,


        }),
      (lineData: Record<string, any>) =>
        sendTest({
          lineData,
          projectHash,


        }),
      (lineData: Record<string, any>) =>
        sendCampaign({
          lineData,
          projectHash


        }),


    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default MailerCampaign;
